import React from 'react';

const VenueDetailsStep = ({ 
    formData, 
    setFormData, 
    shortCodeValidationText,
    emailValidationText, 
    passwordValidationText 
}) => {
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    return (
        <div className="space-y-6">
            <div>
                <h3 className="text-lg font-medium text-white mb-4">Venue Information</h3>
                <div className="grid md:grid-cols-2 gap-4">
                    <div>
                        <label htmlFor="shortCodeKey" className="block text-sm font-medium text-gray-300 mb-2">
                            Short Code Key *
                        </label>
                        <input
                            type="text"
                            id="shortCodeKey"
                            name="shortCodeKey"
                            value={formData.shortCodeKey}
                            onChange={handleChange}
                            maxLength={6}
                            placeholder="ABC123"
                            className="input-field"
                        />
                        <p className="text-xs text-gray-400 mt-1">Max 6 characters. This will be your unique venue identifier.</p>
                        {shortCodeValidationText && (
                            <p className="text-red-400 text-sm mt-1">{shortCodeValidationText}</p>
                        )}
                    </div>
                    
                    <div>
                        <label htmlFor="venueName" className="block text-sm font-medium text-gray-300 mb-2">
                            Venue Name *
                        </label>
                        <input
                            type="text"
                            id="venueName"
                            name="venueName"
                            value={formData.venueName}
                            onChange={handleChange}
                            placeholder="My Awesome Gym"
                            className="input-field"
                        />
                    </div>
                </div>
                
                <div className="grid md:grid-cols-2 gap-4 mt-4">
                    <div className="md:col-span-2">
                        <label htmlFor="address" className="block text-sm font-medium text-gray-300 mb-2">
                            Address
                        </label>
                        <textarea
                            id="address"
                            name="address"
                            value={formData.address}
                            onChange={handleChange}
                            rows={1}
                            placeholder="Venue address"
                            className="input-field"
                        />
                    </div>
                </div>
                
            </div>

            <div>
                <h3 className="text-lg font-medium text-white mb-4">Contact Information</h3>
                <div className="grid md:grid-cols-2 gap-4">
                    <div>
                        <label htmlFor="contactFirstName" className="block text-sm font-medium text-gray-300 mb-2">
                            Contact First Name *
                        </label>
                        <input
                            type="text"
                            id="contactFirstName"
                            name="contactFirstName"
                            value={formData.contactFirstName}
                            onChange={handleChange}
                            placeholder="John"
                            className="input-field"
                        />
                    </div>
                    
                    <div>
                        <label htmlFor="contactSurname" className="block text-sm font-medium text-gray-300 mb-2">
                            Contact Surname *
                        </label>
                        <input
                            type="text"
                            id="contactSurname"
                            name="contactSurname"
                            value={formData.contactSurname}
                            onChange={handleChange}
                            placeholder="Smith"
                            className="input-field"
                        />
                    </div>
                </div>
                
                <div className="mt-4">
                    <label htmlFor="contactEmail" className="block text-sm font-medium text-gray-300 mb-2">
                        Contact Email *
                    </label>
                    <input
                        type="email"
                        id="contactEmail"
                        name="contactEmail"
                        value={formData.contactEmail}
                        onChange={handleChange}
                        placeholder="john@example.com"
                        className="input-field"
                    />
                    {emailValidationText && (
                        <p className="text-red-400 text-sm mt-1">{emailValidationText}</p>
                    )}
                </div>
                
                <div className="grid md:grid-cols-2 gap-4 mt-4">
                    <div>
                        <label htmlFor="password" className="block text-sm font-medium text-gray-300 mb-2">
                            Password * <span className="text-gray-500 font-normal">(8–70 characters)</span>
                        </label>
                        <input
                            type="password"
                            id="password"
                            name="password"
                            value={formData.password}
                            onChange={handleChange}
                            placeholder="••••••••"
                            className="input-field"
                            maxLength={70}
                        />
                    </div>
                    
                    <div>
                        <label htmlFor="confirmPassword" className="block text-sm font-medium text-gray-300 mb-2">
                            Confirm Password *
                        </label>
                        <input
                            type="password"
                            id="confirmPassword"
                            name="confirmPassword"
                            value={formData.confirmPassword}
                            onChange={handleChange}
                            placeholder="••••••••"
                            className="input-field"
                            maxLength={70}
                        />
                    </div>
                </div>
                {passwordValidationText && (
                    <p className="text-red-400 text-sm mt-1">{passwordValidationText}</p>
                )}
            </div>
        </div>
    );
};

export default VenueDetailsStep;
